var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoreR4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_more_r4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-275, -517)",
    stroke: "#0E1C39",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(276, 518)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 3.75,
    height: 3.75,
    rx: 1.875
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 6.25,
    y: 0,
    width: 3.75,
    height: 3.75,
    rx: 1.875
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 6.25,
    width: 3.75,
    height: 3.75,
    rx: 1.875
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 6.25,
    y: 6.25,
    width: 3.75,
    height: 3.75,
    rx: 1.875
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreR4);
export default __webpack_public_path__ + "static/media/icon_more_r4.cb099da932ed3347c31721a27854ed00.svg";
export { ForwardRef as ReactComponent };